export const redirectToOpenbet = (newLocale) => {
  const currentLocale = window.kraken.locale;
  const url = window.location.pathname;
  const newUrl = url.replace('betting', 'bet').replace(currentLocale, newLocale);

  window.location.pathname = newUrl;
};
